import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowUp14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M6.25012 3.81074L3.03051 7.03035L1.96985 5.96969L7.00018 0.939362L12.0305 5.96969L10.9698 7.03035L7.75012 3.81063L7.75012 13H6.25012L6.25012 3.81074Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowUp14.displayName = 'ArrowUp14';
export default ArrowUp14;
